import { CMSApiBase } from './base';

export enum Medal {
  Gold = 'gold',
  Silver = 'silver',
  Bronze = 'bronze',
}

export type PrimeWinnerType = {
  name: string;
  medal: Medal;
  prize: string;
  id?: number;
};

export interface StarWinnersApi extends CMSApiBase {
  primeWinners: PrimeWinnerType[];
}
